import React from 'react';
import { Input } from '../../../../flayr-components/Input/Input';

interface IReasonInputProps {
  autoFocus?: boolean;
  value?: string;
  onChange?: (e: any) => void;
}

const ReasonInput: React.FC<React.PropsWithChildren<React.PropsWithChildren<IReasonInputProps>>> = ({
  value,
  onChange,
  autoFocus,
}) => {
  return (
    <Input
      type="textarea"
      value={value}
      name="reason"
      autoFocus={autoFocus}
      placeholder="Please enter in reason for cancelling the booking"
      size="lg"
      autoExpandHeight
      rows={8}
      onChange={onChange}
      className="text-gray-700"
      validation={['required']}
    />
  );
};
export default ReasonInput;
